import { Component } from 'react'
import expiredImg from '../../../../../assets/images/expired.svg'
import './styles.sass'
import { RouterProps, withRouter } from '../../../../../insfrastructure/utils/with-router-component';

class VerificationExpired extends Component<RouterProps> {
  render() {
    return (
      <div className='sign-up-verification-expired'>
          <div className='content'>
            <div className='block'>
              <div>
                <h3>Link Expirado</h3>
                <p>Este link de verificação expirou ou é inválido.</p>
              </div>
              <img src={expiredImg} alt="Link expirado" />
              <div>
                <p>Tente fazer o login novamente para poder receber um novo link.</p>
              </div>
              <button className='secondary' onClick={() => this.props.navigate('/login')}>Ir para o Login</button>
            </div>
          </div>
      </div>
    )
  }
}

export default withRouter(VerificationExpired)
